import { PaymentInputOption } from 'src/utils/constants/quotes';
import { setInitialPayment } from 'src/utils/contracts';
import { removesScientificNotationFromNumber } from 'src/utils/formatAmout';

export default values => ({
  ...values,
  rate: values.rate ? removesScientificNotationFromNumber(values.rate) : null,
  initialPaymentPorcentaje: values.initialPaymentPorcentaje || null,
  paymentInputOption: values.PaymentInputOption || PaymentInputOption.AMOUNT,
  term: values.term || null,
  equipmentCost: values.equipmentCost || null,
  initialPayment: setInitialPayment(values),
  netInvestment: values.netInvestment || 0,
  rent: values.rent || 0,
  residualPayment: values.residualPayment || 1,
  enableMsi: values.enableMsi || false,
  msiDiscountPercentage: values.discountPercentage || 0,
  msiDiscountAmount: values.discountAmount || 0,
  isFirstUpfrontRentModality: values.isFirstUpfrontRentModality || false
});
